<<!-- kollist列表 -->
<template>
  <div class="line-14 default mt-20 kollist">
    <el-form label-position="right" label-width="80px" class="min-w980" inline>
      <el-form-item label="商品ID">
        <el-input v-model.trim="gsid" class="username"></el-input>
      </el-form-item>
      <el-form-item label="平台">
        <el-select v-model="video_type" class="username">
          <el-option v-for="item in video" :label="item.name" :value="item.label" :key="item.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品名称">
        <el-input v-model.trim="goods_title" class="username"></el-input>
      </el-form-item>
      <el-form-item label="达人昵称">
        <el-input v-model.trim="video_name" class="username"></el-input>
      </el-form-item>
      <el-form-item label="申请时间">
        <el-date-picker
          v-model="create_time_s"
          type="datetime"
          placeholder="选择开始时间"
          style="width:178px;"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <span class="jiange">至</span>
        <el-date-picker
          v-model="create_time_e"
          type="datetime"
          style="width:178px"
          placeholder="选择结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        <el-button @click="restSeach">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 列表 -->
    <el-tabs v-model="active" type="card" @tab-click="handleClick">
      <el-tab-pane :name="item.status" v-for="(item,index) in tag_list" :key="index">
        <span slot="label">{{item.name}}{{item.num}}</span>
      </el-tab-pane>
    </el-tabs>
    <el-table :data="list" style="width:100%;">
      <el-table-column label="带货实拍截止日期" width inline>
        <template slot-scope="scope">
          <div>{{scope.row.coupon_end_time}}</div>
        </template>
      </el-table-column>
      <el-table-column label="商品" width="240" inline>
        <template slot-scope="scope" class>
          <img :src="scope.row.goods_img" class="goods-img fl">
          <div class="fl w-130 ml-6">
            <div class="line-16">{{scope.row.goods_title}}</div>
            <div>商品ID:{{scope.row.other_platform_gsid}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="价格" inline>
        <template slot-scope="scope" class>
          <div>原价:¥{{scope.row.goods_list_money}}</div>
          <div>券后价:¥{{scope.row.real_money}}</div>
          <div
            class="youhuiquan center c-fff"
            v-if="scope.row.is_have_coupon"
          >¥{{Number(scope.row.coupon_money)}}</div>
          <div v-if="scope.row.is_have_coupon">
            <span>已领</span>
            <span class="c-ea4">{{scope.row.coupon_num_suplus}}</span>
            <span>/{{scope.row.coupon_num_total}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="佣金" inline>
        <template slot-scope="scope" class>
          <div>佣比:{{Number(scope.row.user_commission_rate)}}%</div>
          <div>预计收入:¥{{Number(scope.row.user_commission)}}</div>
        </template>
      </el-table-column>
      <el-table-column label="申请时间" inline>
        <template slot-scope="scope" class>
          <div>{{scope.row.create_time}}</div>
        </template>
      </el-table-column>
      <el-table-column label="物流" inline>
        <template slot-scope="scope" class>
          <div>{{scope.row.express_company}}</div>
          <div>{{scope.row.courier_number}}</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" inline>
        <template slot-scope="scope" class>
          <div v-if="scope.row.status==1">待审核</div>
          <div v-if="scope.row.status==2">待发货</div>
          <div v-if="scope.row.status==3">待交付</div>
          <div v-if="scope.row.status==4">交付待确认</div>
          <div v-if="scope.row.status==5">已完成</div>
          <div v-if="scope.row.status==7" class="c-ea4">逾期未交付</div>
          
          <div v-if="scope.row.status==6">
            <p class="c-ea4">审核不通过</p>
            <p class='c-999'>{{scope.row.reason}}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="带货信息" inline>
        <template slot-scope="scope" class>
          <div>平台:{{scope.row.video_type==1?"抖音":"快手"}}</div>
          <div>帐号:{{scope.row.video_name}}</div>
          <div v-if="scope.row.status==5||scope.row.status==4">
            <span>作品:</span>
            <span class="c-ea4 pointer" @click="goZuopin(scope.row.url)">查看</span>
          </div>
          <div v-if="scope.row.status==3">
            <span class="c-ea4 bold fz-14">{{scope.row.day}}</span>
            <span>天内提交作品</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" inline>
        <template slot-scope="scope" class>
          <div v-if="scope.row.status==3">
            <el-button size='mini' type="primary" plain @click="showSubvideo(scope.row)">提交作品</el-button>
          </div>
          <div class="mt-10" v-if="scope.row.is_tao">
            <el-button size='mini' type="primary" plain @click="showTbaobao(scope.row)">转淘口令</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 提交作品的弹框 -->
    <el-dialog title="提交带货作品" :visible.sync="sub" width="556px">
      <div class="sub-t clearfix">
        <img :src="subdata.goods_img" class="some-img fl">
        <div class="fl sub-r">
          <div class="c-000 line-16 lines-1">{{subdata.short_extension_title}}</div>
          <div class="c-999 line-16 fz-14">
            <div class="lines-1">{{subdata.goods_advantage}}</div>
            <div class="lines-1">{{subdata.money_advantage}}</div>
          </div>
        </div>
      </div>
      <div class="line-32 flex mt-20 mb-20">
        <div class="w-120">达人账号</div>
        <el-input :disabled="true" v-model="subdata.video_name"></el-input>
      </div>
      <div class="line-32 flex mt-20 mb-20">
        <div class="w-120">账号id</div>
        <el-input :disabled="true" v-model="subdata.video_id"></el-input>
      </div>
      <div class="line-32 flex mt-20 mb-20">
        <div class="w-120">微信</div>
        <el-input :disabled="true" v-model="subdata.video_wechat"></el-input>
      </div>
      <div class="line-32 flex mt-20">
        <div class="w-120">带货作品链接</div>
        <el-input v-model.trim="subdata.url"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sub=false">取消</el-button>
        <el-button type="primary" @click="subWorks">确认</el-button>
      </span>
    </el-dialog>
    <!-- 转淘口令 -->
    <el-dialog :visible.sync="taobao" width="360px">
      <div class="c-ea4 text-c">复制淘口令，到【{{pingtai}}】即可添加商品！</div>
      <div class="text-c mt-20 mb-20" id="copy">
        <el-input v-model="copy" :disabled="true"></el-input>
      </div>
      <div class="text-c">
        <el-button
          type="primary"
          v-clipboard:copy="copy"
          v-clipboard:success="getCopy"
          v-clipboard:error="onError"
        >点击复制</el-button>
      </div>
    </el-dialog>
    <!-- 页码 -->
    <el-row v-if="count">
      <el-col :span="24" class="flex-bw flex-al line-20 mt-20">
        <div class="fz-13">
          <span>第</span>
          <span class="ml-4 mr-4">{{page}}</span>
          <span>页</span>
        </div>
        <div>
          <div class="block">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="getData"
              :current-page.sync="page"
              :page-size="offset"
              :page-sizes="[10, 20, 30, 40]"
              layout="total,sizes,prev, pager, next, jumper"
              :total="count"
            ></el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>


<script>
import "./tool.css";
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import { setTimeout } from "timers";
Vue.use(VueClipboard);
export default {
  name: "kollist",
  data() {
    return {
      api: {
        userApplyInfo: "/home/userApplyInfo",
        submitUrl: "/home/submitUrl",
        toTurnCheck: "/home/taoCode/toTurnCheck",
        getUserInfo: "/home/getUserInfo",
        turnTaoCode: "/home/taoCode/turnTaoCode" //二合一转换接口
      },
      user_info: "",
      page: 1, //页数
      offset: 10, //条数
      count: "", //当前总的条数
      gsid: "", //商品id
      video_name: "", //平台帐号名称
      goods_title: "", //商品名称
      video_type: "", //渠道 1抖音 2快手',
      create_time_s: "", //	申请开始时间
      create_time_e: "", //	申请结束时间
      status: "0", //状态
      video: [
        {
          label: 1,
          name: "抖音"
        },
        {
          label: 2,
          name: "快手"
        }
      ],

      goods_id: "",
      subdata: {
        //提交带货作品的数据
        video_name: "",
        video_wechat: "",
        video_id: "",
        url: "",
        ayrdid: ""
      },
      time: "",
      active: "0", //tag表头
      sub: false, //提交带货作品
      taobao: false,
      copy: "",
      pingtai: "", //平台
      tag_list: [
        {
          name: "全部",
          num: 0,
          status: "0"
        },
        {
          name: "待审核",
          num: 0,
          status: "1"
        },
        {
          name: "待发货",
          num: 0,
          status: "2"
        },
        {
          name: "待交付",
          num: 0,
          status: "3"
        },
        {
          name: "交付待确认",
          num: 0,
          status: "4"
        },
        {
          name: "已完成",
          num: 0,
          status: "5"
        },
        {
          name: "审核不通过",
          num: 0,
          status: "6"
        },
        {
          name: "逾期未交付",
          num: 0,
          status: "7"
        }
      ],
      list: []
    };
  },
  components: {},
  created() {
    this.userApplyInfo();
  },
  mounted() {},
  methods: {
    userApplyInfo() {
      let _this = this;
      let data = {
        page: this.page,
        offset: this.offset,
        gsid: this.gsid,
        video_name: this.video_name,
        goods_title: this.goods_title,
        video_type: this.video_type,
        status: this.status,
        create_time_s: this.create_time_s,
        create_time_e: this.create_time_e
      };
      this.$http({
        method: "GET",
        url: _this.api.userApplyInfo,
        params: data
      }).then(res => {
        if (res.code == 1) {
          _this.list = res.data;
          _this.list.forEach(item => {
            if (_this.getTime(item.coupon_end_time)) {
              item.is_tao = true;
            } else {
              item.is_tao = false;
            }
          });
          _this.count = res.count;
          _this.getStatusNum(res.status);
        } else {
          if(res.code==413){
            _this.list=[];
            _this.count='';
            _this.count = res.count;
            _this.tag_list[_this.status].num = 0;
            _this.getStatusNum(res.status);
          }
          _this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    //进行搜索
    getList() {
      this.status = "0";
      this.active = "0";
      this.page = 1;
      this.userApplyInfo();
    },
    //获取各个状态下的数量
    getStatusNum(data) {
      console.log(data)
       this.tag_list[0].num = data.a;
          this.tag_list[1].num =data.b;
          this.tag_list[2].num =data.c;
          this.tag_list[3].num = data.d;
          this.tag_list[4].num = data.e;
          this.tag_list[5].num = data.f;
          this.tag_list[6].num =data.g;
          this.tag_list[7].num =data.h;
    },
    getTime(times) {
      let is_tao = "";
      let thisTime = times;
      thisTime = thisTime.replace(/-/g, "/");
      let time = new Date(thisTime);
      time = time.getTime();
      let now = new Date().getTime();
      return Number(now) > Number(time) ? false : true;
    },
    //查看作品
    goZuopin(url) {
      window.open(url);
    },
    showSubvideo(data) {
      this.subdata.url='';
      this.subdata.video_name = data.video_name;
      this.subdata.video_wechat = data.video_wechat;
      this.subdata.video_id = data.video_id;
      this.subdata.goods_img = data.goods_img;
      this.subdata.ayrdid = data.ayrdid;
      this.subdata.short_extension_title=data.short_extension_title;
      this.subdata.goods_advantage=data.goods_advantage;
      this.subdata.money_advantage=data.money_advantage;
      this.sub = true;
    },
    submitUrl() {
      //提交作品
      let _this = this;
      if(!this.subdata.url){
         _this.$message({
            message: "请填写作品链接",
            type: "warning"
          });
          return false;
      }else if(this.subdata.url.indexOf('http')==-1){
          _this.$message({
            message: "请填写正确作品链接",
            type: "warning"
          });
          return false;
      } 
      let data = {
        ayrdid: this.subdata.ayrdid,
        url: this.subdata.url
      };
      this.$http({
        method: "PUT",
        url: this.api.submitUrl,
        params: data
      }).then(res => {
        if (res.code == 1) {
          _this.$message({
            message: "提交成功",
            type: "success"
          });
          _this.userApplyInfo();
          _this.sub = false;
        } else {
          _this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    showTbaobao(datas) {
      let _this = this;
      let once = 0;
      let data = {
        other_platform_gsid: datas.other_platform_gsid,
        title: datas.goods_title,
        type: "taoCode"
      };
      this.pingtai = datas.video_type == 1 ? "抖音" : "快手";
      this.$http({
        method: "GET",
        url: _this.api.turnTaoCode,
        params: data
      }).then(res => {
        if (res.code == 1) {
          if (res.data != -1) {
            _this.taobao = true;
            _this.copy = res.data.data.model;
          } else {
            _this.$message({
              message: "请设置PID",
              type: "warning"
            });
            once++;
            setTimeout(() => {
              window.open("https://xl.linkstars.com/admin/#/my/mypid");
            }, 1000);
          }
        } else {
          if (res.msg == "tao_authorize") {
            _this.$message({
              message: "淘宝未授权",
              type: "warning"
            });
            once++;
          } else if (res.msg == "require_pid") {
            _this.$message({
              message: "请设置pid",
              type: "warning"
            });
            once++;
          } else if (res.msg == "need_setting") {
            _this.$message({
              message: "请设置pid",
              type: "warning"
            });
            once++;
          } else if (res.msg == "authorize_expire") {
            _this.$message({
              message: "淘宝授权已过期",
              type: "warning"
            });
            once++;
          } else if (res.msg == "change_pid") {
            _this.$message({
              message: "pid 不匹配",
              type: "warning"
            });
            once++;
          }
          if (once > 1) {
            setTimeout(() => {
              window.open("https://xl.linkstars.com/admin/#/my/mypid");
            }, 1000);
          }
        }
      });
    },
    toTurnCheck(code) {
      //转淘口令
      let _this = this;
      let data = {
        code: code
      };
      this.$http({
        method: "GET",
        url: _this.api.taokouling,
        params: data
      }).then(res => {
        if (res.code == 1) {
          _this.taobao = true;
        } else {
          _this.$message({
            message: res.data,
            type: "warning"
          });
        }
      });
    },
    handleClick(tab) {
      //table的点击
      this.status = tab.name;
      this.page = 1;
      this.userApplyInfo();
    },
    //重置
    restSeach() {
      this.page = 1;
      this.offset = 10;
      this.gsid = "";
      this.video_name = "";
      this.goods_title = "";
      this.video_type = "";
      this.create_time_s = "";
      this.create_time_e = "";
      this.status = "0";
      this.active = "0";
    },
    subWorks() {
      this.submitUrl()
    },
    getCopy(e) {
      this.$message({
        message: "复制成功",
        type: "success"
      });
    },
    onError() {
      this.$message({
        message: "复制失败，请重试",
        type: "success"
      });
    },
    getUserInfo() {
      let _this = this;
      let data = {};
      this.$http({
        method: "GET",
        url: _this.api.getUserInfo,
        params: data
      }).then(res => {
        if (res.code == 1) {
          _this.user_info = res.data;
        }
      });
    },
    getChange(e) {
      console.log(e);
    },
    handleSizeChange(val) {
      console.log(val)
      this.offset = val;
      this.page = 1;
      this.userApplyInfo();
    },
    getData(val) {
      console.log('page',val)
      this.page = val;
      this.userApplyInfo();
    }
  }
};
</script>
<style  scoped>
.flex {
  display: flex;
}
.min-w980 {
  max-width: 1180px;
}
.jiange {
  margin: 5px;
}
.username{
  width:220px;
}
.goods-img {
  width: 80px;
  height: 80px;
}
.youhuiquan {
  width: 58px;
  height: 22px;
  background: url(../../../src/assets/goods/youhuiquan.png) no-repeat;
  background-size: 58px 22px;
}
.some-img {
  width: 80px;
  height: 80px;
  margin: 6px 10px 6px 6px;
}
.sub-t {
  box-shadow: 3px 3px 3px 0px rgba(3, 3, 3, 0.1);
  border: 1px solid rgba(193, 193, 193, 0.1);
  border-radius: 2px;
}
.sub-r {
  width: 410px;
  height: 80px;
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.w-120 {
  width: 120px;
}
</style>